import * as THREE from 'three'
import { gsap } from 'gsap'
import Experience from "../Experience.js"
import firefliesVertexShader from '../Utils/shaders/fireflies/vertex.glsl'
import firefliesFragmentShader from '../Utils/shaders/fireflies/fragment.glsl'

export default class Fireflies {
    constructor() {
        // Setup
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.PixelRatio = this.experience.sizes.pixelRatio
        this.debug = this.experience.debug

        //Debug
        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder('Fireflies').close()
        }

        // Fireflies
        this.firefliesGeometry = new THREE.BufferGeometry()
        this.firefliesCount = 50
        this.positionArray = new Float32Array(this.firefliesCount * 3)
        this.scaleArray = new Float32Array(this.firefliesCount)

        for (let i = 0; i < this.firefliesCount; i++) {
            this.positionArray[i * 3 + 0] = (Math.random() - 0.5) * 32
            this.positionArray[i * 3 + 1] = (Math.random() * 6) - 3
            this.positionArray[i * 3 + 2] = (Math.random() - 0.5) * 32

            this.scaleArray[i] = Math.random()
        }

        this.firefliesGeometry.setAttribute('position', new THREE.BufferAttribute(this.positionArray, 3))
        this.firefliesGeometry.setAttribute('aScale', new THREE.BufferAttribute(this.scaleArray, 1))

        // Material
        this.firefliesMaterial = new THREE.ShaderMaterial({
            uniforms:
            {
                uTime: { value: 0 },
                uPixelRatio: { value: this.PixelRatio },
                uSize: { value: 300 },
                uStrength: { value: -1.5 }
            },
            vertexShader: firefliesVertexShader,
            fragmentShader: firefliesFragmentShader,
            depthTest: true,
            depthWrite: false,
            depthFunc: THREE.LessEqualDepth,
            //transparent: true,
            blending: THREE.AdditiveBlending
        })

        // Debug
        if (this.debug.active) {
            this.debugFolder
                .add(this.firefliesMaterial.uniforms.uSize, 'value')
                .min(0)
                .max(500)
                .step(1)
                .name('fireFliesSize')
        }

        // Points
        this.fireflies = new THREE.Points(this.firefliesGeometry, this.firefliesMaterial)
        this.fireflies.renderOrder = 1
        this.scene.add(this.fireflies)

        window.setTimeout(() => {
            gsap.to(this.firefliesMaterial.uniforms.uStrength, { duration: 3, value: -0.1 })
        }, 2500)
    }

    update () {
        this.firefliesMaterial.uniforms.uTime.value = this.experience.time.elapsed
    }
}